"use strict";

exports.__esModule = true;
exports.MachineStateCountElementBase = exports.MachineStateCountElement = exports.ConnectedMachineStateCountElement = void 0;
exports.getCompactDisplayValue = getCompactDisplayValue;
exports.getCountColumns = getCountColumns;
exports.getCountDisplayValue = getCountDisplayValue;
exports.getCountLabel = getCountLabel;
exports.getEffectiveStateCount = getEffectiveStateCount;
exports.getMatchingDeviceUuids = getMatchingDeviceUuids;
exports.getScopedDevices = getScopedDevices;
exports.getSharedColumnFontSize = getSharedColumnFontSize;
exports.shouldUseCompactDisplay = shouldUseCompactDisplay;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _API = require("../../API");
var _Device = require("../../Device");
var _Measures = require("../../Measures");
var _approximateFontSize = require("../../Measures/approximateFontSize");
var _MeasurementValue = require("../../Measures/MeasurementValue/MeasurementValue");
var _TextValue = require("../../Measures/TextValue/TextValue");
var _PlantStateActivities = require("../../PlantStateActivities");
var _CurrentClassification = require("../../Timeline/CurrentClassification");
var _Translator = require("../../Core/Translator");
var _MachineStateCountHelpers = require("./MachineStateCountHelpers");
exports.DEFAULT_TOTAL_SEPARATOR = _MachineStateCountHelpers.DEFAULT_TOTAL_SEPARATOR;
exports.resolveTotalSeparator = _MachineStateCountHelpers.resolveTotalSeparator;
var _common = require("../common");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var DEFAULT_REFRESH_INTERVAL = 15 * 60 * 1000;
/**
 * Enabled devices in the current device-filter scope (before plant-state filtering).
 */
function getScopedDevices(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    devices = _ref.devices,
    plantStateFilter = _ref.plantStateFilter;
  var scoped = (plantStateFilter == null ? void 0 : plantStateFilter.sourceDevices) || devices || [];
  return scoped.filter(function (device) {
    return device && device.enabled !== false;
  });
}

/**
 * Display columns for the count widget.
 * Returns [{ key, value, label }] where label is false when hidden.
 */
function getCountColumns(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    stateId = _ref2.stateId,
    stateName = _ref2.stateName,
    count = _ref2.count,
    total = _ref2.total,
    showTotalDevices = _ref2.showTotalDevices,
    showOtherDevices = _ref2.showOtherDevices,
    hideLabel = _ref2.hideLabel,
    error = _ref2.error,
    translate = _ref2.translate;
  var labelOrHidden = function labelOrHidden(text) {
    return hideLabel ? false : text;
  };
  if (!stateId) {
    return [{
      key: "total",
      value: error ? undefined : total,
      label: labelOrHidden(translate ? translate("MachineStateCount.total.label", "Total") : "Total")
    }];
  }
  if (count == null && !error) {
    return [];
  }
  var columns = [{
    key: "state",
    value: error ? undefined : count,
    label: labelOrHidden(stateName || stateId)
  }];
  if (showOtherDevices) {
    columns.push({
      key: "others",
      value: error ? undefined : Math.max(0, (total || 0) - count),
      label: labelOrHidden(translate ? translate("MachineStateCount.others.label", "Others") : "Others")
    });
  }
  if (showTotalDevices) {
    columns.push({
      key: "total",
      value: error ? undefined : total,
      label: labelOrHidden(translate ? translate("MachineStateCount.total.label", "Total") : "Total")
    });
  }
  return columns;
}

/**
 * Whether total extras are shown as compact "N{separator}total".
 * Compact is unavailable when other devices are shown.
 */
function shouldUseCompactDisplay(_temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
    showOtherDevices = _ref3.showOtherDevices,
    stateId = _ref3.stateId;
  if (!stateId) {
    return true;
  }
  return !showOtherDevices;
}

/**
 * Compact value: selected count + separator + total (e.g. "2 of 30", "2 / 30").
 * Only used when total is shown without other devices.
 */
function getCompactDisplayValue(_temp4) {
  var _ref4 = _temp4 === void 0 ? {} : _temp4,
    count = _ref4.count,
    total = _ref4.total,
    error = _ref4.error,
    _ref4$separator = _ref4.separator,
    separator = _ref4$separator === void 0 ? _MachineStateCountHelpers.DEFAULT_TOTAL_SEPARATOR : _ref4$separator;
  if (error || count == null || total == null) {
    return undefined;
  }
  return "" + count + separator + total;
}

/**
 * Shared font size for multi-column values so 1-digit and 3-digit counts match.
 */
function getSharedColumnFontSize(_temp5) {
  var _ref5 = _temp5 === void 0 ? {} : _temp5,
    _ref5$columns = _ref5.columns,
    columns = _ref5$columns === void 0 ? [] : _ref5$columns,
    columnWidth = _ref5.columnWidth,
    height = _ref5.height,
    hideLabel = _ref5.hideLabel,
    labelSize = _ref5.labelSize,
    fontSize = _ref5.fontSize;
  if (fontSize) {
    return fontSize;
  }
  if (!columns.length || !columnWidth || !height) {
    return undefined;
  }
  var labelHeight = hideLabel ? 0 : labelSize != null && labelSize > 0 ? (0, _MeasurementValue.resolveLabelHeight)(height, labelSize) : Math.min(40, Math.max(14, height / 8));
  var valueHeight = height - labelHeight;
  var sizes = columns.map(function (column) {
    var size = (0, _approximateFontSize.approximateFontSize)({
      width: columnWidth,
      height: valueHeight,
      value: column.value == null ? "" : String(column.value)
    });
    return hideLabel ? (0, _TextValue.fitFontSizeToHeight)(size, valueHeight) : size;
  });
  return Math.min.apply(Math, sizes);
}

/**
 * @deprecated Prefer getCountColumns / getCompactDisplayValue.
 */
function getCountDisplayValue(_temp6) {
  var _ref6 = _temp6 === void 0 ? {} : _temp6,
    stateId = _ref6.stateId,
    count = _ref6.count,
    total = _ref6.total,
    showTotalDevices = _ref6.showTotalDevices,
    showOtherDevices = _ref6.showOtherDevices,
    error = _ref6.error,
    totalSeparator = _ref6.totalSeparator;
  if (!stateId) {
    return error ? undefined : total;
  }
  if (showOtherDevices) {
    return error ? undefined : count;
  }
  if (showTotalDevices) {
    return getCompactDisplayValue({
      count: count,
      total: total,
      error: error,
      separator: (0, _MachineStateCountHelpers.resolveTotalSeparator)({
        totalSeparator: totalSeparator
      })
    });
  }
  return error ? undefined : count;
}

/**
 * Label for the primary count column. Returns false when the label should be hidden.
 */
function getCountLabel(_temp7) {
  var _ref7 = _temp7 === void 0 ? {} : _temp7,
    stateId = _ref7.stateId,
    stateName = _ref7.stateName,
    hideLabel = _ref7.hideLabel,
    translate = _ref7.translate;
  if (hideLabel) {
    return false;
  }
  if (!stateId) {
    return translate ? translate("MachineStateCount.total.label", "Total") : "Total";
  }
  return stateName || stateId;
}

/**
 * Unique device UUIDs returned by the timeline/latest aggregate endpoint.
 */
function getMatchingDeviceUuids(response, deviceUuids) {
  if (deviceUuids === void 0) {
    deviceUuids = [];
  }
  if (!Array.isArray(response)) {
    return [];
  }
  var deviceUuidSet = new Set(deviceUuids);
  var matching = [];
  var seen = new Set();
  for (var _iterator = _createForOfIteratorHelperLoose(response), _step; !(_step = _iterator()).done;) {
    var entry = _step.value;
    var uuid = typeof entry === "string" ? entry : undefined;
    if (!uuid || seen.has(uuid)) {
      continue;
    }
    if (deviceUuidSet.size > 0 && !deviceUuidSet.has(uuid)) {
      continue;
    }
    seen.add(uuid);
    matching.push(uuid);
  }
  return matching;
}

/**
 * Count devices in stateId, preferring live classification over REST snapshot.
 */
function getEffectiveStateCount(_temp8) {
  var _ref8 = _temp8 === void 0 ? {} : _temp8,
    _ref8$deviceUuids = _ref8.deviceUuids,
    deviceUuids = _ref8$deviceUuids === void 0 ? [] : _ref8$deviceUuids,
    stateId = _ref8.stateId,
    _ref8$restDeviceState = _ref8.restDeviceStates,
    restDeviceStates = _ref8$restDeviceState === void 0 ? {} : _ref8$restDeviceState,
    _ref8$liveDeviceState = _ref8.liveDeviceStates,
    liveDeviceStates = _ref8$liveDeviceState === void 0 ? {} : _ref8$liveDeviceState;
  if (!stateId) {
    return undefined;
  }
  return deviceUuids.filter(function (deviceUuid) {
    var liveState = liveDeviceStates[deviceUuid];
    var state = liveState !== undefined ? liveState : restDeviceStates[deviceUuid];
    return (0, _MachineStateCountHelpers.deviceMatchesSelectedCount)(state, stateId);
  }).length;
}

/**
 * Displays the count of devices currently in a selected plant state.
 */
var MachineStateCountElementBase = exports.MachineStateCountElementBase = /*#__PURE__*/function (_Component) {
  function MachineStateCountElementBase() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      deviceStates: {},
      error: undefined,
      fetching: false
    };
    // Incremented per fetchCount() call so a stale response can't overwrite a newer one.
    _this.fetchRequestId = 0;
    _this.unregisterDevices = undefined;
    _this.registrationKey = undefined;
    _this.fetchCount = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _this$props, api, stateId, deviceUuids, fetchRequestId, queryStateId, abortController, response, matchingDeviceUuids, matchingDeviceSet, deviceStates, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _this$props = _this.props, api = _this$props.api, stateId = _this$props.stateId;
            deviceUuids = _this.getDeviceUuids();
            fetchRequestId = ++_this.fetchRequestId;
            queryStateId = (0, _MachineStateCountHelpers.getQueryStateId)(stateId);
            _this.abortRequest();
            if (stateId) {
              _context.n = 1;
              break;
            }
            _this.setState({
              deviceStates: {},
              error: undefined,
              fetching: false
            });
            return _context.a(2);
          case 1:
            if (deviceUuids.length) {
              _context.n = 2;
              break;
            }
            _this.setState({
              deviceStates: {},
              error: undefined,
              fetching: false
            });
            return _context.a(2);
          case 2:
            abortController = new window.AbortController();
            _this.abortController = abortController;
            _this.setState({
              error: undefined,
              fetching: true
            });
            _context.p = 3;
            _context.n = 4;
            return api.post("/api/v3/timeseries/timeline/latest", {
              type: ["time-series-classification"],
              entity: {
                device: deviceUuids
              },
              dimensions: {
                state: [queryStateId]
              },
              aggregateBy: {
                entity: ["device"]
              }
            }, false, abortController.signal);
          case 4:
            response = _context.v;
            matchingDeviceUuids = getMatchingDeviceUuids(response, deviceUuids);
            matchingDeviceSet = new Set(matchingDeviceUuids);
            deviceStates = Object.fromEntries(deviceUuids.map(function (deviceUuid) {
              return [deviceUuid, matchingDeviceSet.has(deviceUuid) ? queryStateId : null];
            }));
            if (!abortController.signal.aborted && fetchRequestId === _this.fetchRequestId) {
              _this.setState({
                deviceStates: deviceStates,
                error: undefined,
                fetching: false
              });
            }
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            if (!abortController.signal.aborted && fetchRequestId === _this.fetchRequestId) {
              _this.setState({
                error: _t,
                fetching: false
              });
            }
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[3, 5]]);
    }));
    return _this;
  }
  _inheritsLoose(MachineStateCountElementBase, _Component);
  var _proto = MachineStateCountElementBase.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.fetchCount();
    this.syncRefreshTimer();
    this.syncClassificationRegistration();
  };
  _proto.componentDidUpdate = function componentDidUpdate(previousProps) {
    var _previousProps$plantS, _previousProps$plantS2, _this$props$plantStat;
    var previousDeviceUuids = this.getDeviceUuids(this.getScopedDevicesFromProps(previousProps));
    var deviceUuids = this.getDeviceUuids();
    var stateChanged = previousProps.stateId !== this.props.stateId;
    var devicesChanged = previousDeviceUuids.join() !== deviceUuids.join();
    var previousRefresh = (_previousProps$plantS = previousProps.plantStateFilter) == null ? void 0 : _previousProps$plantS.refreshInterval;
    var refreshInterval = this.getRefreshInterval();
    var manualRefresh = !((_previousProps$plantS2 = previousProps.plantStateFilter) != null && _previousProps$plantS2.shouldRefresh) && ((_this$props$plantStat = this.props.plantStateFilter) == null ? void 0 : _this$props$plantStat.shouldRefresh);
    if (stateChanged || devicesChanged || manualRefresh) {
      this.fetchCount();
    }
    if (stateChanged || previousRefresh !== refreshInterval) {
      this.syncRefreshTimer();
    }
    this.syncClassificationRegistration();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.stopRefreshTimer();
    this.abortRequest();
    this.clearClassificationRegistration();
  };
  _proto.getScopedDevicesFromProps = function getScopedDevicesFromProps(props) {
    if (props === void 0) {
      props = this.props;
    }
    return getScopedDevices({
      devices: props.devices,
      plantStateFilter: props.plantStateFilter
    });
  };
  _proto.getLiveDeviceStates = function getLiveDeviceStates(props) {
    var _props$currentClassif;
    if (props === void 0) {
      props = this.props;
    }
    return ((_props$currentClassif = props.currentClassification) == null ? void 0 : _props$currentClassif.deviceStates) || {};
  };
  _proto.getEffectiveCount = function getEffectiveCount(props, state) {
    if (props === void 0) {
      props = this.props;
    }
    if (state === void 0) {
      state = this.state;
    }
    return getEffectiveStateCount({
      deviceUuids: this.getDeviceUuids(this.getScopedDevicesFromProps(props)),
      stateId: props.stateId,
      restDeviceStates: state.deviceStates,
      liveDeviceStates: this.getLiveDeviceStates(props)
    });
  };
  _proto.syncClassificationRegistration = function syncClassificationRegistration() {
    var _this$props$currentCl;
    var registerDevices = (_this$props$currentCl = this.props.currentClassification) == null ? void 0 : _this$props$currentCl.registerDevices;
    var deviceUuids = this.props.stateId ? this.getDeviceUuids() : [];
    var registrationKey = this.props.stateId ? deviceUuids.join(",") : "";
    if (registrationKey === this.registrationKey && registerDevices === this.registeredRegisterDevices) {
      return;
    }
    this.clearClassificationRegistration();
    this.registrationKey = registrationKey;
    this.registeredRegisterDevices = registerDevices;
    if (typeof registerDevices === "function") {
      this.unregisterDevices = registerDevices(deviceUuids);
    }
  };
  _proto.clearClassificationRegistration = function clearClassificationRegistration() {
    if (typeof this.unregisterDevices === "function") {
      this.unregisterDevices();
    }
    this.unregisterDevices = undefined;
    this.registrationKey = undefined;
    this.registeredRegisterDevices = undefined;
  };
  _proto.getDeviceUuids = function getDeviceUuids(devices) {
    if (devices === void 0) {
      devices = this.getScopedDevicesFromProps();
    }
    return (devices || []).map(function (device) {
      return device.uuid;
    }).filter(Boolean);
  };
  _proto.getRefreshInterval = function getRefreshInterval() {
    var _this$props$plantStat2;
    return ((_this$props$plantStat2 = this.props.plantStateFilter) == null ? void 0 : _this$props$plantStat2.refreshInterval) || DEFAULT_REFRESH_INTERVAL;
  };
  _proto.startRefreshTimer = function startRefreshTimer() {
    var _this2 = this;
    this.stopRefreshTimer();
    if (!this.props.stateId) {
      return;
    }
    this.refreshTimer = window.setInterval(function () {
      return _this2.fetchCount();
    }, this.getRefreshInterval());
  };
  _proto.syncRefreshTimer = function syncRefreshTimer() {
    if (this.props.stateId) {
      this.startRefreshTimer();
    } else {
      this.stopRefreshTimer();
    }
  };
  _proto.stopRefreshTimer = function stopRefreshTimer() {
    if (this.refreshTimer) {
      window.clearInterval(this.refreshTimer);
      this.refreshTimer = undefined;
    }
  };
  _proto.abortRequest = function abortRequest() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = undefined;
    }
  };
  _proto.getStateName = function getStateName(translate) {
    return (0, _MachineStateCountHelpers.getDisplayedStateName)({
      stateId: this.props.stateId,
      plantStateActivities: this.props.plantStateActivities,
      translate: translate
    });
  };
  _proto.renderValue = function renderValue(translate) {
    var _this3 = this;
    var _this$state = this.state,
      error = _this$state.error,
      fetching = _this$state.fetching;
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height;
    var total = this.getScopedDevicesFromProps().length;
    var count = this.getEffectiveCount();
    var columns = getCountColumns({
      stateId: this.props.stateId,
      stateName: this.getStateName(translate),
      count: count,
      total: total,
      showTotalDevices: this.props.showTotalDevices,
      showOtherDevices: this.props.showOtherDevices,
      hideLabel: this.props.hideLabel,
      error: error,
      translate: translate
    });
    var _getMachineStateCount = (0, _MachineStateCountHelpers.getMachineStateCountColors)(Object.assign({
        theme: this.props.theme,
        stateId: (0, _MachineStateCountHelpers.isNonProducingCount)(this.props.stateId) ? undefined : this.props.stateId,
        count: count
      }, (0, _common.getWidgetColorProps)(this.props))),
      color = _getMachineStateCount.color,
      backgroundColor = _getMachineStateCount.backgroundColor;
    var fontProps = (0, _common.getWidgetFontProps)(this.props);
    var interactionProps = (0, _common.getWidgetInteractionProps)(this.props);
    var style = {
      opacity: fetching ? 0.45 : 1
    };
    var totalSeparator = (0, _MachineStateCountHelpers.resolveTotalSeparator)({
      totalSeparator: this.props.totalSeparator
    });
    var useCompact = shouldUseCompactDisplay({
      showOtherDevices: this.props.showOtherDevices,
      stateId: this.props.stateId
    });
    if (columns.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_Measures.MeasurementValue, _extends({}, (0, _common.getWidgetPositionProps)(this.props), fontProps, interactionProps, {
        dataTestId: "MachineStateCount",
        value: undefined,
        label: false,
        centerVertically: this.props.hideLabel,
        color: color,
        backgroundColor: backgroundColor,
        style: style
      }));
    }
    if (useCompact || columns.length === 1) {
      var primary = columns[0];
      return /*#__PURE__*/_react["default"].createElement(_Measures.MeasurementValue, _extends({}, (0, _common.getWidgetPositionProps)(this.props), fontProps, interactionProps, {
        dataTestId: "MachineStateCount",
        value: useCompact && this.props.showTotalDevices && !this.props.showOtherDevices && this.props.stateId ? getCompactDisplayValue({
          count: count,
          total: total,
          error: error,
          separator: totalSeparator
        }) : primary.value,
        label: primary.label,
        labelSize: this.props.labelSize,
        centerVertically: this.props.hideLabel,
        color: color,
        backgroundColor: backgroundColor,
        style: style
      }));
    }
    var columnWidth = width / columns.length;
    var sharedFontSize = getSharedColumnFontSize({
      columns: columns,
      columnWidth: columnWidth,
      height: height,
      hideLabel: this.props.hideLabel,
      labelSize: this.props.labelSize,
      fontSize: fontProps.fontSize
    });
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      "data-testid": "MachineStateCount"
    }, interactionProps, {
      style: Object.assign({}, style, {
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        width: width,
        height: height,
        overflow: "hidden",
        backgroundColor: backgroundColor || undefined,
        boxSizing: "border-box"
      })
    }), columns.map(function (column) {
      return /*#__PURE__*/_react["default"].createElement(_Measures.MeasurementValue, _extends({
        key: column.key
      }, fontProps, {
        fontSize: sharedFontSize,
        x: 0,
        y: 0,
        width: columnWidth,
        height: height,
        dataTestId: "MachineStateCount." + column.key,
        value: column.value,
        label: column.label,
        labelSize: _this3.props.labelSize,
        centerVertically: _this3.props.hideLabel,
        color: color,
        style: {
          flex: "1 1 0",
          minWidth: 0
        }
      }));
    }));
  };
  _proto.render = function render() {
    var _this4 = this;
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref0) {
      var translate = _ref0.translate;
      return _this4.renderValue(translate);
    });
  };
  return MachineStateCountElementBase;
}(_react.Component);
MachineStateCountElementBase.defaultProps = {
  api: undefined,
  devices: [],
  plantStateActivities: undefined,
  plantStateFilter: undefined,
  currentClassification: undefined,
  theme: undefined,
  showTotalDevices: false,
  showOtherDevices: false,
  totalSeparator: _MachineStateCountHelpers.DEFAULT_TOTAL_SEPARATOR,
  hideLabel: false,
  labelSize: 0.2
};
function withCurrentClassification(TargetComponent) {
  function WithCurrentClassification(props) {
    return /*#__PURE__*/_react["default"].createElement(_CurrentClassification.CurrentClassificationContext.Consumer, null, function (currentClassification) {
      return /*#__PURE__*/_react["default"].createElement(TargetComponent, _extends({}, props, {
        currentClassification: currentClassification
      }));
    });
  }
  WithCurrentClassification.displayName = "withCurrentClassification(" + (TargetComponent.displayName || TargetComponent.name || "Unknown") + ")";
  return WithCurrentClassification;
}
var MachineStateCountElement = exports.MachineStateCountElement = (0, _styledComponents.withTheme)(withCurrentClassification(MachineStateCountElementBase));
var ConnectedMachineStateCountElement = exports.ConnectedMachineStateCountElement = _PlantStateActivities.PlantStateActivitiesContext.withContext(_PlantStateActivities.PlantStateFilterContext.withContext(_Device.DeviceListContext.withContext(_API.RestAPIContext.withContext(MachineStateCountElement))));